import { useState } from 'react';
import type { ComponentProps, KeyboardEvent } from 'react';
import { Input } from '@kiipu/ui';
import { Eye, EyeSlash } from '@phosphor-icons/react';

type InputProps = ComponentProps<typeof Input>;

/** Password input with reveal toggle and a caps-lock hint. */
export function PasswordInput({ onKeyDown, onKeyUp, onBlur, ...props }: InputProps) {
  const [visible, setVisible] = useState(false);
  const [capsLock, setCapsLock] = useState(false);
  const detect = (event: KeyboardEvent<HTMLInputElement>) =>
    setCapsLock(event.getModifierState?.('CapsLock') ?? false);
  return (
    <>
      <div className="signin-password">
        <Input
          {...props}
          type={visible ? 'text' : 'password'}
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          onKeyDown={(event) => {
            detect(event);
            onKeyDown?.(event);
          }}
          onKeyUp={(event) => {
            detect(event);
            onKeyUp?.(event);
          }}
          onBlur={(event) => {
            setCapsLock(false);
            onBlur?.(event);
          }}
        />
        <button
          type="button"
          className="signin-reveal"
          aria-pressed={visible}
          aria-label={visible ? '隐藏密码' : '显示密码'}
          onClick={() => setVisible((value) => !value)}
        >
          {visible ? <EyeSlash size={16} /> : <Eye size={16} />}
        </button>
      </div>
      {capsLock ? (
        <p className="signin-hint" role="status">
          大写锁定已开启
        </p>
      ) : null}
    </>
  );
}

/** The identity chosen in step one, with a way back to change it. */
export function EmailChip({
  email,
  onChange,
  disabled,
}: {
  email: string;
  onChange(): void;
  disabled?: boolean;
}) {
  return (
    <div className="signin-chip">
      <span className="signin-chip-avatar" aria-hidden="true">
        {email.charAt(0).toUpperCase()}
      </span>
      <span className="signin-chip-email" title={email}>
        {email}
      </span>
      <button type="button" className="signin-link" onClick={onChange} disabled={disabled}>
        更改
      </button>
    </div>
  );
}
